<script setup lang="ts">
import { computed } from 'vue';
import Button from 'primevue/button';

type GroupByOption = 'day' | 'week';

interface Props {
  modelValue: GroupByOption;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'update:modelValue': [value: GroupByOption];
}>();

const groupBy = computed<GroupByOption>({
  get() {
    return props.modelValue;
  },
  set(value: GroupByOption) {
    emit('update:modelValue', value);
  }
});

const options = [
  { key: 'day' as const, label: 'Daily', icon: 'pi pi-calendar' },
  { key: 'week' as const, label: 'Weekly', icon: 'pi pi-calendar-times' }
];

function selectGroupBy(option: GroupByOption) {
  groupBy.value = option;
}
</script>

<template>
  <div class="grouping-controls">
    <div class="flex gap-1">
      <Button
        v-for="option in options"
        :key="option.key"
        :label="option.label"
        :icon="option.icon"
        :severity="groupBy === option.key ? 'primary' : 'secondary'"
        :outlined="groupBy !== option.key"
        size="small"
        @click="selectGroupBy(option.key)"
      />
    </div>
  </div>
</template>

<style scoped>
.grouping-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
